module.exports = __webpack_public_path__ + "img/43.a4f17bcc.jpg";